import { useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { Dispatch } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import { change } from 'redux-form'

import { disableInputs } from './claim/claim-actions'
import { buildHeaders } from './lib/buildHeaders'
import { getBaseUrl } from './lib/helpers'
import { findAuthUnauth } from './upload/upload-actions'

type PrefillProps = {
  addValue(form: string, key: string, value: string): void
  disableInputs(): void
  findAuthUnauth(sourceSystem: string): void
}

type PrefillType = {
  sourceSystem: string
  claimNumber: string
  dateOfLoss: string
  identityName: string
  identityEmail: string
  roleInClaim: string
}

const PrefillComponent = (props: PrefillProps) => {
  const { token } = useParams()
  const navigate = useNavigate()
  const addValues = useCallback((prefill: PrefillType) => {
    const { addValue, disableInputs } = props
    if (prefill.claimNumber) addValue('claimForm', 'claimNumber', prefill.claimNumber)
    if (prefill.dateOfLoss) {
      // In Safari new Date() can have troubles parsing dates with - as a separator
      // Replacing this separator with / fixes this issue for modern versions of Safari
      // Input date formats include mm-dd-yyyy, mm/dd/yyyy, m/d/yyyy
      const formattedDate = dayjs(prefill.dateOfLoss).format('MM/DD/YYYY')

      addValue('claimForm', 'dateOfLoss', formattedDate)
    }
    if (prefill.claimNumber && prefill.dateOfLoss) disableInputs()
    if (prefill.identityName) addValue('identityForm', 'identityName', prefill.identityName)
    if (prefill.identityEmail) addValue('identityForm', 'identityEmail', prefill.identityEmail)
    if (prefill.sourceSystem) props.findAuthUnauth(prefill.sourceSystem)
    // adding prefill for trackingId
    if (prefill.roleInClaim) {
      addValue('identityForm', 'roleInClaim', prefill.roleInClaim)
    }
  }, [props])

  const getPrefill = useCallback(async () => {
    if (token) {
      try {
        const res = await fetch(
          `${getBaseUrl()}claimfileuploaderapi/v1/prefill/decode`,
          {
            method: 'POST',
            body: JSON.stringify({ token }),
            headers: buildHeaders({ 'Content-Type': 'application/json' }),
            credentials: 'omit'
          }
        )
        const prefill = await res.json()
        addValues(prefill)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch(e) {
        // do nothing
      }
    }
    navigate(window.travURI)
  }, [token, addValues, navigate])

  useEffect(() => {
    void getPrefill()
  }, [getPrefill])

  return <div>Loading...</div>
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  addValue: (form: string, field: string, value: string) => dispatch(change(form, field, value)),
  disableInputs: () => dispatch(disableInputs()),
  findAuthUnauth: (sourceSystem: string) => dispatch(findAuthUnauth(sourceSystem))
})

const Prefill = connect(null, mapDispatchToProps)(PrefillComponent)

export {
  Prefill
}
